import { MdUnfoldMore } from 'react-icons/md';
import { Button, Modal, Panel, Table } from 'rsuite';
import { BigNumbersBox } from '../../../../../../components/BigNumbersBox';
import styles from './ModalPlanoMonitoramento.module.scss';

const { Column, HeaderCell, Cell } = Table;

export type UsuarioMonitoramentos = {
  usuario: string;
  monitoramentosAtivos: number;
};

export type PlanoMonitoramentoData = {
  monitoramentosIncluidosNoPlano?: number;
  monitoramentosAtivos?: number;
  monitoramentosDisponiveis?: number;
  monitoramentosCriadosPorMim?: number;
  monitoramentosInativos?: number;
  consumoPorUsuario?: UsuarioMonitoramentos[];
};

type ModalPlanoMonitoramentoProps = {
  show: boolean;
  onClose: () => void;
  onRequestMore?: () => void;
  data?: PlanoMonitoramentoData;
};

export const ModalPlanoMonitoramento = ({ show, onClose, onRequestMore, data }: ModalPlanoMonitoramentoProps) => (
  <Modal className={styles.modal} show={show} onHide={onClose}>
    <Modal.Header className={styles.header} closeButton>
      <Modal.Title className={styles.title}>Veja o seu plano de Monitoramento Infopanel</Modal.Title>
    </Modal.Header>
    <Modal.Body className={styles.body}>
      <div className={styles.boxWrapper}>
        <BigNumbersBox.Root className={styles.box} marginRight="0">
          <BigNumbersBox.MainValue>{data?.monitoramentosIncluidosNoPlano ?? '-'}</BigNumbersBox.MainValue>
          <BigNumbersBox.RegularText>Monitoramentos inclusos</BigNumbersBox.RegularText>
          <BigNumbersBox.RegularText>no plano</BigNumbersBox.RegularText>
        </BigNumbersBox.Root>
        <BigNumbersBox.Root className={styles.box} marginRight="0">
          <BigNumbersBox.MainValue>{data?.monitoramentosAtivos ?? '-'}</BigNumbersBox.MainValue>
          <BigNumbersBox.RegularText>Monitoramentos</BigNumbersBox.RegularText>
          <BigNumbersBox.RegularText>ativos</BigNumbersBox.RegularText>
        </BigNumbersBox.Root>
        <BigNumbersBox.Root className={styles.box} marginRight="0">
          <BigNumbersBox.MainValue>{data?.monitoramentosDisponiveis ?? '-'}</BigNumbersBox.MainValue>
          <BigNumbersBox.RegularText>Monitoramentos</BigNumbersBox.RegularText>
          <BigNumbersBox.RegularText>disponíveis</BigNumbersBox.RegularText>
        </BigNumbersBox.Root>
        <BigNumbersBox.Root className={styles.box} marginRight="0">
          <BigNumbersBox.MainValue>{data?.monitoramentosCriadosPorMim ?? '-'}</BigNumbersBox.MainValue>
          <BigNumbersBox.RegularText>Monitoramentos criados</BigNumbersBox.RegularText>
          <BigNumbersBox.RegularText>por mim</BigNumbersBox.RegularText>
        </BigNumbersBox.Root>
        <BigNumbersBox.Root className={styles.box} marginRight="0">
          <BigNumbersBox.MainValue>{data?.monitoramentosInativos ?? '-'}</BigNumbersBox.MainValue>
          <BigNumbersBox.RegularText>Monitoramentos</BigNumbersBox.RegularText>
          <BigNumbersBox.RegularText>inativos</BigNumbersBox.RegularText>
        </BigNumbersBox.Root>
      </div>
      <div className={styles.infoBox}>
        <p>A quantidade de monitoramentos é definida por contrato, independentemente do número de usuários da sua equipe.</p>
        <p>
          Para contratar mais monitoramentos, entre em contato com o seu CSM por e-mail ou clicando no botão &quot;Quero mais monitoramentos&quot; abaixo.
        </p>
      </div>
      <Panel header="Entenda o consumo de monitoramentos do seu contrato" collapsible bordered className={styles.panel}>
        <Table data={data?.consumoPorUsuario ?? []} autoHeight bordered className={styles.consumptionTable}>
          {/* @ts-ignore */}
          <Column flexGrow={1}>
            <HeaderCell className={styles.tableHeaderCell}>Usuário</HeaderCell>
            <Cell dataKey="usuario" />
          </Column>
          {/* @ts-ignore */}
          <Column flexGrow={1} align="right">
            <HeaderCell className={styles.tableHeaderCell}>
              <span className={styles.sortableHeader}>
                Monitoramentos ativos
                <MdUnfoldMore size={16} className={styles.sortIcon} />
              </span>
            </HeaderCell>
            <Cell dataKey="monitoramentosAtivos" />
          </Column>
        </Table>
      </Panel>
    </Modal.Body>
    <Modal.Footer className={styles.footer}>
      <Button onClick={onClose} appearance="ghost">
        Fechar
      </Button>
      <Button onClick={onRequestMore} appearance="primary">
        Quero mais monitoramentos
      </Button>
    </Modal.Footer>
  </Modal>
);
